import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ProfileProjects from '../components/profile/ProfileProjects';
import { RESOLVE_LOCAL_USER_STATE } from '../components/auth/AuthActions';
import UserCard from '../components/user/UserCard';
import SweetLoadingSpinner from "../components/eyeCandy/SweetLoadingSpinner.js";
import { FETCH_USER, FETCH_EXTENDED_USER, FETCH_PROJECTS } from '../components/profile/ProfileActions.js';

export default function ProfilePage() {
  const { username } = useParams();

  const [auth_user] = useState(RESOLVE_LOCAL_USER_STATE());
  const [profile_user, setProfileUser] = useState('');
  const [profile_extended_user, setProfileExtendedUser] = useState('');
  const [profile_projects, setProfileProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const u = await FETCH_USER(username);
        const [ext, projects] = await Promise.all([
          FETCH_EXTENDED_USER(u.id),
          FETCH_PROJECTS(u.id, true),
        ]);
        if (!cancelled) {
          setProfileUser(u);
          setProfileExtendedUser(ext);
          setProfileProjects(projects);
          setLoading(false);
        }
      } catch (e) {
        console.error('ProfilePage Load Error:', e);
        console.error('ProfilePage Load Error Response:', e.response);
        console.error('ProfilePage Load Error Status:', e.response?.status);
        console.error('ProfilePage Load Error Data:', e.response?.data);
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [username]);

  const auth_user_pk = auth_user?.pk;
  const profile_user_pk = profile_user?.pk;
  const auth_profile_user = !!auth_user_pk && !!profile_user_pk && auth_user_pk === profile_user_pk;

  return (
    <div className="container" style={{ paddingTop: '50px' }}>
      <div className="row">
        <div className="col-md-3 col-sm-3 col-xs-12">
          <SweetLoadingSpinner loadingState={loading} />
          <UserCard
            user={profile_user}
            extended_user={profile_extended_user}
            back_home={auth_profile_user}
          />
        </div>

        <div className="col-md-9 col-sm-9">
          <h6>
            <span style={{ color: 'var(--ink)', backgroundColor: 'var(--bg-soft)', padding: '5px' }}>
              Projects
            </span>
          </h6>
          <hr />
          <div className="container">
            <SweetLoadingSpinner loadingState={loading} />
            <ProfileProjects projects={profile_projects} />
          </div>
        </div>
      </div>
    </div>
  );
}


// import React from 'react';

// import ProfileProjects from '../components/profile/ProfileProjects'


// import { RESOLVE_LOCAL_USER_STATE } from '../components/auth/AuthActions';

// import UserCard from '../components/user/UserCard';

// import SweetLoadingSpinner from "../components/eyeCandy/SweetLoadingSpinner.js";
// import { FETCH_USER, FETCH_EXTENDED_USER, FETCH_PROJECTS } from '../components/profile/ProfileActions.js';

// class ProfilePage extends React.Component {
//     constructor(props){
//         super(props);
//         this.state = {
//             auth_user: RESOLVE_LOCAL_USER_STATE(),
//             profile_username: this.props.match.params.username,
//             profile_user: '',
//             profile_extended_user: '',
//             profile_projects: [],
//             loading: true
//         }
//     }
//     componentDidMount() {
//         FETCH_USER(this.state.profile_username).then(res => {
//             const returned_user = res;
//             FETCH_EXTENDED_USER(returned_user.id).then(res2 => {
//                 const returned_extended_user = res2;
//                 // fetching published projects by user id
//                 FETCH_PROJECTS(returned_user.id, true).then(res3 => {
//                     const returned_projects = res3;
                    
//                     // now resetting state after all that cake and watermelon
//                     this.setState({
//                         profile_user: returned_user,
//                         profile_extended_user: returned_extended_user,
//                         profile_projects: returned_projects,
//                         loading: false
//                     })
//                 })
//             })
//         })
//     }
//     render() {
//         const auth_user_pk = this.state.auth_user.pk;
//         const profile_user_pk = this.state.profile_user.pk;
//         const auth_profile_user = (auth_user_pk === profile_user_pk);
//         return (
//             <div
//                 className="container"
//                 style={{
//                     paddingTop: '50px',
//                 }}
//             >
//                 <div className="row">
//                     <div className="col-md-3 col-sm-3 col-xs-12">
//                         <SweetLoadingSpinner loadingState={this.state.loading} />
//                         <UserCard user={this.state.profile_user} extended_user={this.state.profile_extended_user} back_home={auth_profile_user} />
//                     </div>
//                     <div className="col-md-9 col-sm-9">
//                         <h6><span style={{color: 'black', backgroundColor:'rgba(0,0,0,.05', padding: '5px'}}>Projects</span></h6>
//                         <hr />
//                         <div className="container">
//                             <SweetLoadingSpinner loadingState={this.state.loading} />
//                             <ProfileProjects projects={this.state.profile_projects} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

// export default ProfilePage;